import { vexStockImages } from '~/constants/environment';

/* Handler for default image */
export default function defaultImageHandler(event: any) {
  const defaultImageURL = `${vexStockImages}/generic_vehicle_desktop_1920x1080.png`;
  // To prevent infinite loop in case the defaultImageURL fails too
  if (event.target.src !== defaultImageURL) {
    event.target.src = defaultImageURL;
  }
}
